"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleMappingColumnProps = exports.userRoleColumnPropsFullSize = exports.userRoleColumnProps = exports.userRoleTypes = void 0;
const constants_1 = require("utils/constants");
exports.userRoleTypes = {
    SET_ERROR: 'USER ROLE TYPES ON ERROR',
    ON_DELETE: 'USER ROLE TYPES ON DELETE',
    SET_LOADING: 'USER ROLE TYPES SET LOADING',
    SET_DATA_GRID: 'USER ROLE TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'USER ROLE TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'USER ROLE TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'USER ROLE TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'USER ROLE TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'USER ROLE TYPES ON CHANGE DATAITEM',
};
exports.userRoleColumnProps = [
    {
        show: true,
        field: 'name',
        title: 'Access Level',
        width: '482',
        filter: 'text',
    },
    {
        show: true,
        field: 'authorization_count',
        title: 'Authorization',
        width: '422',
        filterable: false
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '270',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '160',
        filter: 'boolean',
    },
];
exports.userRoleColumnPropsFullSize = [
    {
        show: true,
        field: 'name',
        title: 'Access Level',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'authorization_count',
        title: 'Authorization',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '270',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '160',
        filter: 'boolean',
    },
];
exports.roleMappingColumnProps = [
    {
        show: true,
        field: 'moduie',
        title: 'Module',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'subModule',
        title: 'Sub Module',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'mobile',
        title: 'Mobile',
        width: 'auto',
        filter: 'text',
        innerColumn: [
            {
                show: true,
                field: 'mobile_view',
                title: 'View',
                width: '120px',
                filter: 'boolean',
            },
            {
                show: true,
                field: 'mobile_change',
                title: 'Change',
                width: '120px',
                filter: 'boolean',
            },
        ],
    },
    {
        show: true,
        field: 'web',
        title: 'Web',
        width: 'auto',
        filter: 'text',
        innerColumn: [
            {
                show: true,
                field: 'web_view',
                title: 'View',
                width: '120px',
                filter: 'boolean',
            },
            {
                show: true,
                field: 'web_change',
                title: 'Change',
                width: '120px',
                filter: 'boolean',
            },
        ],
    },
];
